export default {
  // 更新loading状态
  uppdateIsLoading(state, payload) {
    state.isLoading = payload;
  },
  uppdateNavMenuActive(state, payload) {
    state.NavMenuActive = payload;
  },
  // 更新登录的userinfo信息
  updateUserInfo(state, payload) {
    state.userInfo = payload;
  },
  updateUserName(state, payload) {
    state.userName = payload;
  },
  // 更新登陆返回的企业信息
  updateCorporationInfo(state, payload) {
    state.corporationInfo = payload;
  },
  // 首页弹窗是否第一次
  isDialog(state, payload) {
    state.isDialog = payload;
  },
  updateIs404(state, payload) {
    state.is404 = payload;
  },
  updateCompanyList(state, payload) {
    state.companyList = payload;
  },
  updateCompanyModal(state, payload) {
    state.isCompanyModal = payload;
  },
  updateMenuTop(state, payload) {
    state.menuTop = payload;
  },
  upcreator(state, payload) {
    state.creator = payload;
  },
  upcorpCertityStatus(state, payload) {
    state.corpCertityStatus = payload;
  },
  upuserCertityStatus(state, payload) {
    state.userCertityStatus = payload;
  },
  upisopen(state, payload) {
    state.isopen = payload;
  },
  upcompanyName(state, payload) {
    state.companyName = payload;
  },
  upopenflag(state, payload) {
    state.openflag = payload;
  },
  upchecked(state, payload) {
    state.checked = payload;
  },
  upadmin(state, payload) {
    state.admin = payload;
  },
  upAxiosAll(state, payload) {
    state.axiosAll = payload;
  },
  upAccountInfo(state, payload) {
    state.accountInfo = payload;
  },
  upheadUser(state, payload) {
    state.headUser = payload;
  },
  updateAgentSMSValidateStatus(state, payload) {
    state.agentSMSValidateStatus = payload;
  },
};
